import { combineEpics } from 'redux-observable';
import { onLoadPricingRulesDoneEpic } from './_epics/onLoadPricingRulesDoneEpic.epic';
import { onUpdatePricingRulesDoneEpic } from './_epics/onUpdatePricingRulesDoneEpic.epic';
import { onValidatePricingRulesDoneEpic } from './_epics/onValidatePricingRulesDoneEpic.epic';
import { validatePricingRulesEpic } from './_epics/validatePricingRules.epic';

export const controllerPricingRulesEpic = combineEpics(
  onLoadPricingRulesDoneEpic,
  onUpdatePricingRulesDoneEpic,
  onValidatePricingRulesDoneEpic,
  validatePricingRulesEpic,
);
